import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, type ModifierParams } from '../modifier.type';
import type { Damage } from '../damage.type';
import { addModifier, type Player } from '../player.type';
import { actionHistory } from '../../../store';
import { StatusEffect } from '../status-effects.type';
import { StatusEffectRegistry } from '../status-effects';

export class Imbue extends Modifier {
  static readonly baseTitle = 'Imbue';
  static readonly baseText = 'Apply Status Effect of type, equal to the damage dealt, on attack.';
  static readonly baseIcon = 'imbue';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Imbue.baseTitle;
  text = Imbue.baseText;
  icon = Imbue.baseIcon;
  tags: Array<ModifierTags> = [...Imbue.baseTags];
  priority = Imbue.basePriority;

  imbue: StatusEffect | undefined;

  constructor() {
    super();
    this.type = StatusEffect.Imbue;
    this.imbue = undefined;
  }

  clone(newOwner: Player) {
    var clone = super.clone(newOwner);
    clone.imbue = this.imbue;

    return clone;
  }

  init(params: ModifierParams) {
    if (actionHistory && params) {
      actionHistory.push(`${this.owner.title} gained Imbue (${params.imbue}).`);
    }
    this.imbue = params.imbue;
    this.title = `${Imbue.baseTitle} (${this.imbue})`;
    this.bonusIcon = this.imbue;
    this.update(0, params);
  }

  update(stacks: number, params?: ModifierParams) {
    if (!params?.imbue) {
      throw new Error('Imbue modifier requires imbue type in params.');
    }

    if (this.imbue !== params.imbue) {
      actionHistory.push(
        `${this.owner.title} changed imbue from ${this.imbue} to ${params.imbue}.`,
      );
      this.imbue = params.imbue;
      this.title = `${Imbue.baseTitle} (${this.imbue})`;
      this.bonusIcon = this.imbue;
      this.stacks = 0;
    }

    if (stacks) {
      this.stacks += stacks;
      actionHistory.push(`Added ${stacks} ${this.type} to ${this.owner.title}.`);
    }
  }

  damageOut(damage: Damage) {
    if (this.imbue) {
      addModifier(damage.target, this.imbue, 1);
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Imbue, Imbue);
